var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AjanlatBase',{attrs:{"titleExtra":_vm.titleExtra}},[_c('div',{attrs:{"slot":"biztositoi-adatok"},slot:"biztositoi-adatok"},[_vm._v("\n        Verzió: "+_vm._s(_vm.version)+" "+_vm._s(_vm.name)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }